export const blurActiveElementWithin = (root: HTMLElement | undefined): void => {
  const activeElement = document.activeElement;
  if (activeElement instanceof HTMLElement && root?.contains(activeElement)) activeElement.blur();
};
